import React, { Component } from 'react';

import FirstHeader from '../components/firstHeader';
import Header from '../components/header';
import Fastbooking from '../components/fastbooking';
import Middlesection from '../components/middleSection';
import Footer from '../components/footer';
import SectionInformationBoxes from '../components/sectionInformationBoxes';
import {connect} from 'react-redux';

import Secctiontext from './secctiontext';

class pageText extends Component {
  render() {
    return (
      <div className='route-PageText'>
        <FirstHeader />
        <Header isMenu={true} />

        <Fastbooking color='white'/>
        <Middlesection section='pagetext'/>
        <Secctiontext/>
        <SectionInformationBoxes/>

        <Footer />
      </div>
    )
  }
}

export default connect(
  (state) => ({settings: state.settings})
)(pageText)



// WEBPACK FOOTER //
// ./src/shared/routes/routePageText/index.js